import { SpotPendingPosition } from '@flipster/r230522/original/spot-order';
import { numberFormatter } from '@flipster/utils/num';

import { IPositionLineAdapter } from '../../../../../lib/charting_library/charting_library';
import { ChartStyles } from '../../../../misc/constants';
import TradingView from '../../../../trading-view';

const SpotOrderLineMapper = {
  Buy: {
    bodyColor: ChartStyles.Color.TriggerLong,
    lineColor: ChartStyles.Color.Up,
  },
  Long: {
    bodyColor: ChartStyles.Color.TriggerLong,
    lineColor: ChartStyles.Color.Up,
  },
  Sell: {
    bodyColor: ChartStyles.Color.TriggerShort,
    lineColor: ChartStyles.Color.Down,
  },
  Short: {
    bodyColor: ChartStyles.Color.TriggerShort,
    lineColor: ChartStyles.Color.Down,
  },
};

class SpotOrderLineHelper {
  #lines: Record<string, IPositionLineAdapter> = {};

  constructor(
    private readonly tv: TradingView,
    private readonly label: string,
    private readonly getValue: (order: SpotPendingPosition) => number,
  ) {}

  draw(symbol: string, orders: SpotPendingPosition[]) {
    if (this.tv.symbol !== symbol) return;
    // 기존 라인중 사라진것 삭제
    Object.keys(this.#lines).forEach((id) => {
      if (!orders.find((p) => p.orderId === id)) this.#remove(id);
    });
    // 라인 업데이트
    [...orders].forEach((o) => this.#draw(o));
  }

  #draw(order: SpotPendingPosition) {
    try {
      if (!this.tv.enabled || !this.tv.activeChart) return;
      const lineInfo = SpotOrderLineMapper[order.side];
      this.#lines[order.orderId] ??= this.tv
        .createPositionLine()
        .setLineColor(lineInfo.lineColor)
        .setBodyTextColor(ChartStyles.Color.White)
        .setBodyBackgroundColor(lineInfo.bodyColor)
        .setBodyBorderColor(lineInfo.bodyColor)
        .setQuantityTextColor(ChartStyles.Color.White)
        .setQuantityBackgroundColor(ChartStyles.Color.Background)
        .setQuantityBorderColor(lineInfo.bodyColor);
      this.#lines[order.orderId]
        .setText(this.label + ' ' + numberFormatter(order.qty))
        .setPrice(this.getValue(order))
        .setQuantity('');
    } catch {
      // Value is null error
    }
  }

  #remove(id: string) {
    this.#lines[id]?.remove();
    delete this.#lines[id];
  }

  clean() {
    Object.keys(this.#lines).forEach((id) => {
      this.#remove(id);
    });
  }
}

export default SpotOrderLineHelper;
